export default "__VITE_ASSET__DNKS8d2n__"